module.exports = __webpack_public_path__ + "static/media/gray-tick.3d7cb768.svg";